import axios from 'axios';
import {StartEndTime} from "../TVGuide";

export function fetchTVGuide(country:'south-africa'|'nigeria') {
    const retrieveTheGuide = () => country === 'south-africa' ? axios.get('https://d1ozdip280arix.cloudfront.net/tv-guides/today.json') : axios.get('https://d1ozdip280arix.cloudfront.net/nigeria-tv-guide/today.json');
    return retrieveTheGuide().then(response=> {
        const tvGuide = response.data;

        const programShowTimes: { [titleId: number]: StartEndTime[] } = {};

        const tvGuideDates = Object.keys(tvGuide)
            .filter(key => key.match(/\d{4}-\d{2}-\d{2}/))
            .filter(key => tvGuide[key]['Channels'].length > 0);

        for (const tvGuideDate of tvGuideDates) {
            const channels = tvGuide[tvGuideDate]['Channels'];
            for (const channel of channels) {
                const programmes = channel['Programmes'];
                for (const programme of programmes) {
                    const startTimeYYYMMDDHHmmss = `${tvGuideDate}T${programme.StartTime}`;
                    const endTimeYYYMMDDHHmmss = `${tvGuideDate}T${programme.EndTime}`;
                    const currentList: StartEndTime[] = programShowTimes[programme.TitleId] || [];
                    currentList.push({startTime: startTimeYYYMMDDHHmmss, endTime: endTimeYYYMMDDHHmmss});
                    programShowTimes[programme.TitleId] = currentList;
                }
            }
        }

        //Now update Programme MetaData
        const programTitles = Object.keys(programShowTimes);
        for (const titleId in programTitles) {
            const metaData = tvGuide['ProgrammeMetaData'][titleId];
            if (metaData) {
                metaData.ShowTimes = programShowTimes[titleId];
            }
        }
        return {data:tvGuide}
    });
};

export function fetchPoliticalComicManifest() {
    // Local dev uses the CRA dev proxy (see "proxy" in package.json) so the S3
    // bucket doesn't need CORS; production fetches the S3 URL directly unless
    // REACT_APP_COMIC_MANIFEST_URL points at a CORS-enabled endpoint.
    const url = process.env.REACT_APP_COMIC_MANIFEST_URL
        || (process.env.NODE_ENV === 'development'
            ? '/political-comics/comic-strip.json'
            : 'https://segoo-inc-public.s3.us-east-2.amazonaws.com/political-comics/comic-strip.json');
    return axios.get(url);
}

export function fetchMovieCrosswordManifest() {
    // Local dev uses the CRA proxy (see setupProxy.js) so the S3 bucket does
    // not need CORS; production fetches the public manifest directly unless a
    // CORS-enabled endpoint is supplied at build time.
    const url = process.env.REACT_APP_CROSSWORD_MANIFEST_URL
        || (process.env.NODE_ENV === 'development'
            ? '/movie-crosswords/crossword.json'
            : 'https://segoo-inc-public.s3.us-east-2.amazonaws.com/movie-crosswords/crossword.json');
    return axios.get(url);
}

export const fetchTVShowDetails = async (country:'south-africa'|'nigeria', uniqueEventId: string) => {
    const map = {'south-africa': 'zaf', 'nigeria': 'nga'};

    const url = `https://api.tv-guide.segoo-inc.com/proxy-program-details-fetch-javascript`;

    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
    const maxRetries = 3;

    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            const response = await axios.get(url, {
                params: {
                    country: map[country],
                    eventId: uniqueEventId
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = typeof response.data === "string"
                ? JSON.parse(response.data)
                : response.data;
            if (data?.Duration) {
                return response;
            }
            throw new Error("Empty programme details response");
        } catch (err) {
            if (attempt === maxRetries) throw err;
            await sleep(2000 * (attempt + 1));
        }
    }
    throw new Error("unreachable");
};
